var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('h2',[_vm._t("default")],2),_c('div',{staticClass:"right__title__elements"},[(_vm.$slots.buttons)?_c('div',{staticClass:"section-title__buttons"},[_vm._t("buttons")],2):_vm._e(),(_vm.$slots.sort)?_c('div',{staticClass:"section-title__sort"},[_vm._t("sort")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }